import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import tableSlice from "components/elements/table/reducer/table.slice";
import formDrawerSlice from "../components/elements/formDrawer/formdrawer.slice";
import LoginSlice from "./reducers/LoginSlice";
import sidebarReducer from "./reducers/SidebarSlice";
import notificationSlice from './reducers/NotificationSlice';
import studentReducer from './reducers/studentSlice';
import examScoresReducer from './reducers/examScoresSlice';

const store = configureStore({
  reducer: {
    sideBarData: sidebarReducer,
    formDrawerState: formDrawerSlice,
    tableState: tableSlice,
    LoginState: LoginSlice,
    notification: notificationSlice,
    students: studentReducer,
    examScores: examScoresReducer,
    // reducers...
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
